var hiddenClass = 'visuallyhidden';


// console.log('gallery.js');
function galleryFilters()
{
  var filters = {};

  //loop through each filter set option group
  $('.js-filter-set').each(function ()
  {
    var group = $(this).data('group');
    filters[group] = [];

    $(this).find(':checkbox:checked').each(function ()
    {
      if ($(this).data('id') !== 'all')
      {
        filters[group].push('.filter_' + $(this).data('id'));
      }
    });
  });

  //console.log(filters);

  var i = 0;
  var comboFilters = [];
  var message = [];

  for (var prop in filters)
  {
    message.push(filters[prop].join(' '));
    var filterGroup = filters[prop];
    // skip to next filter group if it doesn't have any values
    if (!filterGroup.length)
    {
      continue;
    }
    if (i === 0)
    {
      // copy to new array
      comboFilters = filterGroup.slice(0);
    }
    else
    {
      var filterSelectors = [];
      // copy to fresh array
      var groupCombo = comboFilters.slice(0); // [ A, B ]
      // merge filter Groups
      for (var k = 0, len3 = filterGroup.length; k < len3; k++)
      {
        for (var j = 0, len2 = groupCombo.length; j < len2; j++)
        {
          filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
        }

      }
      // apply filter selectors to combo filters for next group
      comboFilters = filterSelectors;
    }
    i++;
  }

  var comboFilter = comboFilters.join(', ');
  //console.log(comboFilter);
  return comboFilter;
}

if ($('.js-filter-set-project-types').find('input:checked').length > 1)
{
  $('.js-project-types-all').prop('checked', false);
}

var $container = $('.gallery__list').imagesLoaded(function ()
{
  $container.isotope({
    itemSelector: '.gallery__item',
    masonry: {
      gutter: 23,
      isFitWidth: true
    },
    filter: galleryFilters()
  });

  $container.isotope('on', 'layoutComplete', function ()
  {
    var iso = $container.data('isotope');
    // check filtered jQuery object
    if (!iso.filteredItems.length)
    {
      $('.js-gallery-no-results').removeClass(hiddenClass);
    }
  });
});



$('.js-filter-set input').change(function ()
{
  var id = $(this).data('id'),
    filterSet = $(this).parents('.js-filter-set');

  $('.js-gallery-no-results').addClass(hiddenClass);

  if (id == 'all')
  {
    filterSet.find('input').prop('checked', false);
    $(this).prop('checked', true);
  }
  else
  {
    var filterSetCheckedCount = filterSet.find('input:checked').length;

    if (filterSetCheckedCount)
    {
      filterSet.find('[data-id="all"]').prop('checked', false);
    }
    else
    {
      filterSet.find('[data-id="all"]').prop('checked', true);
    }

  }

  var filters = galleryFilters();
  $container.isotope({filter: filters});
});
